import React from "react";
import AssetCategoryPage from "./AssetCategoryPage";

const BuildingAssets = () => {
  return <AssetCategoryPage category="Building" title="Building" />;
};

export default BuildingAssets;
